module.exports = __webpack_public_path__ + "img/small-bell2.558b43c1.svg";